export default __webpack_public_path__ + "static/merchant_large_harvey_norman-a8f761c287508e38698b8356b6b2bbb0.png";